export default __webpack_public_path__ + "static/media/gavel.600cb566.svg";